import { jsx as _jsx } from "react/jsx-runtime";
var SkillXp = function SkillXp(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 1 0 0-2H4V3Zm4 6a1 1 0 1 1 1.651.759 1.008 1.008 0 0 0-.142.102A1 1 0 0 1 8 9Zm4 0c0 .62-.188 1.195-.509 1.672l1.289 1.587a2.99 2.99 0 0 1 1.905-.18l1.978-3.198a3 3 0 1 1 1.701 1.051L16.37 13.16a3 3 0 1 1-5.043.481l-1.441-1.773A3 3 0 1 1 12 9Zm2.483 5.124a1.036 1.036 0 0 0 .121.08 1 1 0 1 1-.122-.08ZM19 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
      fill: color
    })
  });
};
export default SkillXp;